var exports = {
  "qS": "xfd349460--7b8b50--badge",
  "YP": "xfd349460--7b8b50--badge-text",
  "f2": "xfd349460--7b8b50--badge-description",
};

module.exports = exports;
